<template>
<div>
    <loading :active='isLoading' :is-full-page="fullPage" :loader="loader" />
    
        <div class="container-fluid custom-container-others">
            <div class="row">
                <div class="col-md-12">
                    <i @click="backToProducts()" style="margin-right:15px" class="fas fa-arrow-left"></i><span class="heading-font-size">{{storeName}}</span>
                    <img src="../assets/img/svg/Icon_awesome-check-circle.svg" class="img-fluid check-circle ml-3 mb-2" alt="Responsive image">
                </div>
                <div class="col-md-4 mb-3 text-muted">
                    <small>{{address}}</small>
                </div>
                <div class="col-md-12 mb-3">
                    <small><b>SECURE CHECKOUT</b></small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">
                    
                    <div class="row account">
                        <div class="col-md-12">
                            <h3>Account</h3>
                            <small>To place your order now, log in to your existing account or sign up.</small>
                        
                        <div class="row" v-if="!successfullLogin">
                            <div class="col  mt-3"  >
                                <a id="loginOrSignUp" data-toggle="modal" data-target="#login-phone" data-whatever="@mdo"><button class="btn login-btn"><b>Login or Sign Up</b></button></a>
                                
                            </div>
                        </div>
                            <div class="row mt-3" v-if="successfullLogin">
                                <div class="col-md-8">
                                    <span v-if="citizenName != ''" class="user-name"><strong>{{citizenName}},</strong></span><span class="text-muted"><b class="user-name">{{userContactNo}}</b></span>
                                </div>
                                <div class="col-md-4 not-you text-right pr-5">
                                    <span><a data-toggle="modal" data-target="#addressCheck" id="notYou"  class="text-danger cCursorhover"><b></b></a></span>
                                </div>
                            </div>
                    </div>
                    </div>
                    <!-- eslint-disable -->
                    <div class="row account mt-4 pl-0" v-for="bandcheck in bandList" :key="bandcheck.id" v-if="bandcheck.Band == 'ADDRESS' && bandcheck.Show == 'Y' && (showDeliveryBlock == 'home' || showDeliveryBlock == 'home1')">
                        <!-- eslint-enable -->
                         
                        <div class="col-md-12">
                            <h3>Delivery Address</h3>
                            <small v-if="!selected"><b>Choose your delivery address</b></small>
                        </div>
                        <div class="col-md-12 new-address mt-3" v-if="successfullLogin && !selected">
                            <a data-toggle="modal" data-target="#selectaddress" class="continue-color cCursorhover"><img src="../assets/img/add-circle-outline.svg" class="img-fluid mr-2" alt="Responsive image"><span @click="changeEditable()"><b>Add New Address</b></span></a>
                        </div>
                        <div class="col-md-12 new-address mt-3" v-if="addressList.length != 0 && !selected">
                            <a  class="text-muted"><img src="../assets/img/svg/Icon awesome-map-marker-alt.svg" class="img-fluid mr-2 cCustombold " alt="Responsive image"><span><b>Saved Addresses</b></span></a>
                        </div>
                        <!-- eslint-disable -->
                        
                          <div class="col-md-12 new-address mt-3 pt-2 pb-2" v-if="selected">
                            <a  class="text-dark"><img src="../assets/img/svg/Icon ionic-ios-checkmark-circle-outline.svg" class="img-fluid" alt="Responsive image"><span class="new-address"><b>{{selectedAddress.AddressTag}}</b></span></a> <span class="continue-color ml-3"><small><b>- {{selectedAddress.Distance}} kms</b></small></span>
                             <span class="text-danger float-right cCursorhover" @click="changeAddress()">
                                Change
                            </span>
                            <p v-if="selectedAddress.UnitNo != ''" class="new-address text-muted ml-4"><small><b>{{selectedAddress.UnitNo}},{{selectedAddress.FloorAndTower}},{{selectedAddress.Locality}},{{selectedAddress.CityName}}</b></small></p>
                            <p v-if="selectedAddress.UnitNo == ''" class="new-address text-muted ml-4"><small><b>{{formattedAddress}}</b></small></p>
                            <div class="cDeliverable"> 
                            <span class="valid-address text-white cCursorhover cCustombold "><small><b>Selected</b></small></span>
                            </div>
                        </div>


                        <div class="col-md-12 new-address mt-3 pt-2 pb-2" v-for="address in addressList" :key="address.id" v-if="address.Serviceable == 'Y' && !selected">
                            <a  class="text-dark"><img src="../assets/img/svg/Icon ionic-ios-checkmark-circle-outline.svg" class="img-fluid" alt="Responsive image"><span class="new-address"><b>{{address.AddressTag}}</b></span></a> <span class="continue-color ml-3"><small><b>- {{address.Distance}} kms</b></small></span>
                             <span class="float-right">
                                <div class="dropdown">
                                    <i class="fas fa-ellipsis-v mr-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item cCursorhover" data-toggle="modal" data-target="#selectaddress" @click="EditAddress(address)">Edit</a>
                                        <a class="dropdown-item cCursorhover" @click="DeleteAddress(address)">Delete</a>
                                    </div>
                                </div>
                            </span>
                            <p v-if="address.UnitNo != ''" class="new-address text-muted ml-4"><small><b>{{address.UnitNo}},{{address.FloorAndTower}},{{address.Locality}},{{address.CityName}}</b></small></p>
                            <p v-if="address.UnitNo == ''" class="new-address text-muted ml-4"><small><b>{{formattedAddress}}</b></small></p>
                            <div class="cDeliverable"> 
                            <span class="valid-address text-white cCursorhover cCustombold " v-if="!selected" @click="selectAddress(address)"><small><b>Deliver Now</b></small></span>
                            </div>
                        </div>
                        <div class="col-md-12 new-address-text mt-3 mb-3" v-for="address in addressList" :key="address.id" v-if="address.Serviceable == 'N' && !selected">
                            <a class="text-dark"><b>{{address.AddressTag}}</b></a> <span class="continue-color ml-3"><small><b>- {{address.Distance}} kms</b></small></span>
                            <span class="float-right">
                                <div class="dropdown">
                                    <i class="fas fa-ellipsis-v mr-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" data-toggle="modal" data-target="#selectaddress" @click="EditAddress(address)">Edit</a>
                                        <a class="dropdown-item" @click="DeleteAddress(address)">Delete</a>
                                    </div>
                                </div>
                            </span>
                            <p v-if="address.UnitNo != ''" class="text-muted"><small><b>{{address.UnitNo}},{{address.FloorAndTower}},{{address.Locality}},{{address.CityName}}</b></small></p>
                            <p v-if="address.UnitNo == ''" class="new-address text-muted ml-4"><small><b>{{formattedAddress}}</b></small></p>
                            <span class="invalid-address text-danger"><small><b>This address is not serviceable</b></small></span>
                        </div>
                        <!-- eslint-enable -->
                    </div>
                    <div class="row checkbox-content mt-4 mb-4">
                        <div class="col-md-12">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="defaultCheck">
                                <label class="form-check-label" for="defaultCheck">Opt in for No-contact Delivery</label>
                                <label class="form-check-label mt-2" for="defaultCheck"><small>Our delivery partner will call  (or ring your doorbell) after reaching and leave  the order at your door/gate  (Not applicable for COD)</small></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-12 account">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <span class="heading-font-size2">Cart</span>
                                    <p class="mb-0"><small><b>{{itemCount}} ITEM</b></small></p>
                                    <span class="text-muted cCustombold "><b>Delivering to</b></span>
                                </div>
                            </div>
                            <div class="row pl-1 mb-3">
                                <div class="col-md-12 user-detail d-flex" v-if="citizenName != '' && successfullLogin">
                                    <div class="col-md-3 col-3 align-self-center pr-0">
                                        <img v-if="UserImgUrl == null" src="../assets/img/user-profile.jpg" class="rounded-circle user-image" height="41px" width="41px" alt="User image">
                                        <img v-if="UserImgUrl != null" v-bind:src="UserImgUrl" class="rounded-circle user-image" height="41px" width="41px" alt="User image">
                                    </div>
                                    <div class="col-md-9 col-9 pl-0 ml-2 align-self-center">
                                        <small><b>{{citizenName}}, {{userContactNo}}</b></small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3 mt-3">
                                <div class="col-md-12">
                                    <a href="#"><img src="../assets/img/Page-1.svg" class="img-fluid mr-2" alt="Responsive image"></a>
                                    <b class="text-muted"><span class="mb-0 cCustombold ">{{deliveryTimeText}}</span></b>
                                    <a href="#" class="text-danger float-right cCursorhover" data-toggle="modal" data-target="#DeliveryTime"><small>Change</small></a>
                                </div>
                                <div class="col-md-11 right-side-content-margin">
                                    <p class="mb-0"><small><b>{{deliveryDate}}, {{deliveryTime}}</b></small></p>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="selected">
                                <div class="col-md-12">
                                    <a href="#"><img src="../assets/img/Icon material-location-on.svg" class="img-fluid mr-2" alt="Responsive image"></a>
                                    <b class="text-muted"><span class="mb-0">Delivery Address</span></b>
                                    <a class="text-danger float-right cCursorhover"  @click="changeAddress()"><small>Change</small></a>
                                </div>
                                <div class="col-md-11 right-side-content-margin">
                                    <p v-if="selectedAddress.UnitNo != ''" class="mb-0"><small class="address-details"><b>{{selectedAddress.UnitNo}},{{selectedAddress.FloorAndTower}},{{selectedAddress.Locality}},{{selectedAddress.CityName}}</b></small><br /></p>
                                    <p v-if="selectedAddress.UnitNo == ''" class="mb-0"><small class="address-details"><b>{{formattedAddress}}</b></small><br /></p>
                                   
                                    <!-- <small class="text-muted">Delivery time is 45 mins</small> -->
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-12">
                                    <a ><img src="../assets/img/Icon map-food.svg" class="img-fluid mr-2" alt="Responsive image"></a>
                                    <b class="text-muted cCustombold ">Your Items</b>
                                    
                                </div>
                            </div>
                            <!-- eslint-disable -->
                            <div class="row mb-3 d-flex" v-for="product in productsList" :key="product.id" v-if="product.ProductName != null">
                                <!-- eslint-enable -->
                                <div class="col">
                                    <!-- <a ><img src="../assets/img/veg.png" class="img-fluid mr-2" alt="Responsive image"></a> -->
                                    <b><small><b>{{product.ProductName}}</b> {{product.Variants}}<br>{{currencyText}} {{product.Price}}</small></b>
                                </div>

                        <div class="col-4 col-md-4 col-lg-4 quantity-btn text-right"> 
                            <div class="btn-group">  
                                <button class="qantity-decrement btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="minus(product)">-</button>
                                <input class="product-quantity custom-quantity-btn count-quantity text-white quantity border-0 text-center" v-bind:id="product.PH" name="quantity" type="number" min="1" max="10" v-bind:value="product.Q" readonly/>
                                <button class="quantity-increment btn btn-sm custom-quantity-btn operator-btn text-white border-0" @click="add(product)">+</button>
                            </div>
                        </div>

                            </div>
                            <div class="col-md-12">
                                    <hr/>
                                </div>

                            <div class="row mb-3" v-if="!instructionBoolean">
                                <div class="col-md-12 text-muted text-center cCursorhover">
                                    <small data-toggle="modal" data-target="#addInstructions">Add special instructions (optional)</small>
                                </div>
                            </div>

                            <div class="row" v-if="instructionBoolean">
                                <div class="col-md-12 add-items toggle">
                                <span class="toggle" >Order Instructions</span>
                                <button data-toggle="modal" data-target="#addInstructions" class="btn float-right"><i  class="fas fa-pencil-alt mr-2"></i>Edit</button>
                                </div>
   
                                <div class="col-md-12">
                                <small>{{deliveryInstruction}}</small>
                                
                                </div>
                                
                            </div>
                            <hr/>
                            <div class="row pl-1" v-if="askTip && (showDeliveryBlock == 'home' || showDeliveryBlock == 'home1')">
                                <div class="col-md-12 p-4 support-your-rider">
                                    <p class="mb-0"><b>SUPPORT YOUR RIDER</b></p>
                                    <small class="text-muted test-paragraph">Would you like to tip your rider?</small>
                                    <div class="btn-part mt-3">
                                        <button class="btn price-button" v-for="tip in riderTipList" :key="tip.id" v-bind:id="tip" @click="addTip(tip)">{{currencyText}}{{tip}}</button>
                                    </div>
                                </div>
                            </div>
                            <!-- eslint-disable -->
                            <div v-for="item in items" :key="item.id">
                            <div class="row pt-3 pb-3" v-for="bandcheck in bandList" :key="bandcheck.id" v-if="bandcheck.Band == 'OFFERS' && bandcheck.Show == 'Y' && item[0].JSon3.length !=0 ">
                                <!-- eslint-enable -->
                                <div class="col pr-0">
                                    <small class="promo"><img src="../assets/img/discount (1).svg" class="img-fluid mr-2" alt="Responsive image">Select a promo code</small>
                                </div>
                                <div class="col view-all-offers text-right pr-2">
                                    <a data-toggle="modal" data-target="#offersModal"><small class="align-self-center view-all pl-2 pr-2">View all offers</small><span class="chevron-icon"><i class="fas fa-chevron-right ml-2 pr-2"></i></span></a>
                                </div>
                            </div>
                            </div>
                            <div class="row pl-1">
                                <div class="col-md-12 total-row mb-3">
                                    <!-- eslint-disable -->
                                    <div class="row pb-2" v-for="charges in chargesList" :key="charges.id" v-if="charges.ID != 'PAYABLE'">
                                        <div class="col">
                                            <small>{{charges.DESC}}:</small>
                                        </div>
                                        <div class="col text-right" v-if="charges.DESC != 'Remarks'">
                                            <small>{{currencyText}}{{charges.AMOUNT}}</small>
                                        </div>
                                    </div>
                                    <div class="row grand-total" v-for="charges in chargesList" :key="charges.id" v-if="charges.ID == 'PAYABLE'" >
                                        <!-- eslint-enable -->
                                        <div class="col">
                                            <h6 id="paymentGateway" @click="openPaymentGateway()" class="grand-total">{{charges.DESC}}</h6>
                                        </div>
                                        <div class="col text-right">
                                            <h6 class="grand-total">{{currencyText}}{{charges.AMOUNT}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 pay-now">
                                    <a>
                                        
                                        <button type="button" @click="payNow()" class="btn btn-block pay-btn">PAY NOW<i class="fas fa-arrow-right ml-3"></i></button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!-- Modals -->
<div class="modal fade modal-add" id="addInstructions" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title product-heading-modal" id="exampleModalLongTitle">Add Order Instructions</h6>
        <button type="button" class="close add-more"  data-dismiss="modal" aria-label="Close">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <textarea rows="6" placeholder="Add Instruction" id="instructionValue" v-bind:value="deliveryInstruction" class="form-control p-2" maxlength="50"></textarea>
    
          <input data-dismiss="modal" @click="saveInstruction()" value="SAVE" class="btn btn-block modal-submit mt-2">
        </form>
      </div>
    </div>
  </div>
</div>



<div class="modal fade login show" id="login-phone" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Login or Sign Up</h5>
                <button type="button" class="close" id="phoneLogin" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4 pb-4">
                <form class=" pb-4">
                    <div class="form-group">
                        <label class="col-form-label continue-color"><b>Phone Number</b></label>
                        <div class="input-group mb-2 text-muted">
                             <div class="input-group-prepend">
                                            <div class="input-group-text prepend-background border-right-0 p-0">
                                                <select @change="getCountryDetails($event)" class="form-control custom-select number-code-text prepend-background border-0" id="inputGroupSelect01">
                                                    <option v-for="country in countryList" :key="country.id" v-bind:value="country.CountryCode">{{country.CountryCode}}</option>
                                                </select>
                                            </div>
                            </div>
                            <input type="number" v-on:keyup="validatePhone($event)" class="form-control prepend-background border-left-0 text-muted" maxlength="10" id="contact" name="contact" placeholder="Enter phone number" />
                        </div>
                        <div class="errorMessage">
                            {{phoneErrorMessage}}
                        </div>
                    </div>
                    <div class="form-group">
                        <a data-toggle="modal" data-target="#enter-otp" data-whatever="@mdo"><button type="submit" @click="submitOtp()" class="btn btn-block create-account text-white bgBlue">Send OTP</button></a>
                    </div>
                </form>
                <div class="row">
                    <div class="col-md-12">
                        <b class="continue-color other-sign-font">Other Sign In Options</b>
                    </div>
                </div>
                <div class="google-sign mt-4 pl-4 pr-4">
                    <a  class="text-dark cCursorhover"><img src="../assets/img/search.svg" height="29px" width="29px" class="img-fluid mr-2"><small><b class="other-sign-font">Sign In with Google</b></small></a>
                </div>
                
                
                    <div class="google-sign mt-3 pl-4 pr-4" data-toggle="modal"  data-dismiss="modal" data-target="#login-email">
                    <a class="text-dark cCursorhover"><img src="../assets/img/Group 175.svg" height="29px" width="29px" class="img-fluid mr-2"><small><b class="other-sign-font">Sign In with Email</b></small></a>
                    </div>
                   
                    <div class="google-sign mt-3 pl-4 pr-4" @click.prevent="loginWithFacebook">
                    <a class="text-dark cCursorhover"><img data-v-d78a55b6="" src="../assets/img/Icon_awesome-facebook.svg" height="29px" width="29px" class="img-fluid mr-2"><small ><b  class="other-sign-font">Sign In with Facebook</b></small></a>
                    </div>

                   
            </div>
        </div>
    </div>
</div>

<div v-if="verifyOtpBoolean" class="modal fade login show" id="enter-otp" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Enter OTP</h5>
                <button type="button" class="close" id="otpClose" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12 pb-3">
                        <small class="otp-heading"><b>Enter One Time Password, You received on {{countryCode}} {{userContactNo}}</b></small>
                    </div>
                </div>
                <div class="row">
                    <div class="col pr-0">
                        <input type="text" id="otp-1" v-on:keyup="movetoOtp2()" class="form-control otp-textarea text-center" maxlength="1" autofocus />
                    </div>
                    <div class="col p-0">
                        <input type="text" id="otp-2" v-on:keyup="movetoOtp3()" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                    <div class="col p-0">
                        <input type="text" id="otp-3" v-on:keyup="movetoOtp4()" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                    <div class="col pl-0">
                        <input type="text" id="otp-4" v-on:keyup="validateOtp()" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                </div>
                <div class="errorMessage">
                            {{OtpErrorMessage}}
                        </div>
                <div class="row pt-3">
                    <div class="col-md-12 anchor-tag-text pb-4 text-right">
                        <a  @click="submitOtp()" v-if="!resend">
                            <small @click="resendOtp()" class="cResendotp cCursorhover"><b>Didn't receive the code? Resend OTP</b></small>
                            
                        </a>
                        <a v-if="resend">
                            <p class="mb-0" id="resend-otp-again"><small><b>Resend OTP in {{countdown}} Seconds</b></small></p>
                        </a>
                    </div>
                    <div class="col-md-12">
                        <button type="button" @click="verifyOtp()" id="verifyOtp"   class="btn btn-block create-account bgBlue"><a  class="text-white" >CONTINUE</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade login show"   id="login-name" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Login or Sign Up</h5>
                <button type="button" class="close" data-dismiss="modal" id="closeName" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4 pb-4">
                <form @submit.prevent="onSubmit()">
                    <div class="form-group">
                        <label class="col-form-label continue-color"><b>Your Name</b></label>
                        <div class="input-group mb-2 text-muted">
                            <div class="input-group-prepend">
                                <div class="input-group-text prepend-background border-right-0"><img src="../assets/img/Icon awesome-user-alt.svg" class="img-fluid"></div>
                            </div>
                            <input type="text" v-on:keyup="validateName($event)" class="form-control prepend-background border-left-0 is-valid" id="username"  name="name" placeholder="Enter your name"/>
                            <!-- <div class="valid-feedback">
                                <img src="../assets/img/Icon awesome-check-circle.svg" class="img-fluid mr-2">Best name ever
                            </div> -->
                       
                        </div>
                    </div>
                     <div class="errorMessage">
                            {{NameErrorMessage}}
                        </div>
                    <div class="mt-4">
                        <a><button type="submit" @click="updateName()" class="btn btn-block create-account text-white bgBlue" >CREATE ACCOUNT</button></a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade login show" id="login-email" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Login or Sign Up</h5>
                <button type="button" class="close" id="closeEmail" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4 pb-4">
                <form>
                    <div class="form-group">
                        <div class="input-group mb-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text prepend-background border-right-0"><i class="fas fa-envelope continue-color email-icon"></i></div>
                            </div>
                            <input type="email" v-on:keyup="validateEmail($event)" class="form-control prepend-background border-left-0" id="emailId" name="name" placeholder="Enter your email">
                        </div>
                    </div>
                    <div class="errorMessage">
                            {{emailErrorMessage}}
                        </div>
                    
                </form>
                <div class="mt-4">
                        <a data-toggle="modal" data-target="#login-email-message"><button type="submit" @click="SendOtpToMail()" class="btn btn-block create-account text-white bgBlue" >CONTINUE</button></a>
                    </div>
                    <div class="anchor-tag-text text-right mt-3">
                        <a ><small class="otp-heading"><b>We’ll send you OTP & Login link on your email instantly</b></small></a>
                    </div>
            </div>
        </div>
    </div>
</div>
 
<div v-if="emailSuccess" class="modal fade login show" id="login-email-message" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Enter OTP</h5>
                <button type="button" class="close" id="closeEmailOtp" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pr-4 pl-4">
                <div class="row justify-content-center">
                    <div class="col-md-4 text-center">
                        <img src="../assets/img/message@2x.png" class="img-fluid email-image">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 pt-3 text-center">
                        <span class="continue-color"><small><b>Please check the email for OTP & Login link</b></small></span>
                    </div>
                    <div class="col-md-12 pb-3 text-center">
                        <small><b>We have sent OTP & Login link on your email</b></small>
                    </div>
                </div>
                <div class="row">
                    <div class="col pr-0">
                        <input type="text" id="otp-9" v-on:keyup="movetoOtp10()" class="form-control otp-textarea text-center" maxlength="1" autofocus />
                    </div>
                    <div class="col p-0">
                        <input type="text" id="otp-10" v-on:keyup="movetoOtp11()" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                    <div class="col p-0">
                        <input type="text" id="otp-11" v-on:keyup="movetoOtp12()" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                    <div class="col pl-0">
                        <input type="text" id="otp-12" v-on:keyup="validateEmailOtp($event)" class="form-control otp-textarea text-center" maxlength="1"  />
                    </div>
                </div>
                 <div class="errorMessage">
                            {{EmailOtpErrorMessage}}
                </div>
                <div class="row pt-3">
                    <div class="col-md-12 anchor-tag-text pb-4 text-right">
                        <a @click="SendOtpToMail()">
                            <small @click="resendEmailOtp()" class="otp-heading"><b>Didn’t Received Email? Resend Verification Email</b></small>
                        </a>
                    </div>
                    <div class="col-md-12">
                        <button type="button" @click="verifyEmailOtp()" id="verifyEmail" class="btn btn-block create-account bgBlue"><a  class="text-white">Continue</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade login show" id="DeliveryTime" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Schedule Delivery</h5>
                <button type="button" class="close" id="closeDelivery" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>

            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <button type="button" data-dismiss="modal" class="btn btn-block cModalbtnenable">Process Immediately</button>
                        </div>
                        <div class="col-12" data-toggle="modal" data-target="#scheduleForLater" @click="ScheduleDelivery()">
                            <button type="button" class="btn btn-block cModalbtndisable">Schedule For Later</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 text-center mt-4">
                    <p>Your order will be processed ASAP (As soon as possible).</p>
                    <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/images/schedule.png" alt="">
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal fade login show" id="scheduleForLater" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">Set Delivery Time</h5>
                <button type="button" class="close" id="closeScheduleLaterModel" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>


            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-12 mb-2">
                            
                        <button @click="BackToImmediate()" data-toggle="modal" data-target="#DeliveryTime" type="button" class="btn btn-block cModalbtndisable">Process Immediately</button>
                        </div>
                        <div class="col-12">
                            <button type="button" class="btn btn-block cModalbtnenable">Schedule For Later</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-body pr-4 pl-4 pb-4">
                <div class="col-md-12">
                    <form>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery Date</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date prepend-padding-right border-right-0">
                                            <i class="far fa-calendar-alt"></i></div>
                                        <input type="date" v-on:change="Datepicker($event)" v-bind:min="today"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="datepicker" v-bind:value="deliveryDate" />

                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="col-form-label"><small><b>Select Delivery time</b></small></label>
                                    <div class="input-group-prepend custom-text-color">
                                        <div
                                            class="input-group-text date-time-background border-radius-date border-right-0">
                                            <i class="far fa-clock"></i></div>
                                        <input type="time" v-on:change="Timepicker($event)"
                                            class="form-control date-time-background border-radius-text border-left-0"
                                            name="timepicker" v-bind:value="deliveryTime" />
                                        <div class="input-group-append">
                                            <span
                                                class="input-group-text date-time-background border-radius-forword border-left-0"><i
                                                    class="fas fa-chevron-right"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-md-12">

                <button data-dismiss="modal" type="button" @click="confirmDeliveryTime()" class="btn btn-block pay-btn mb-4">Confirm Delivery Time</button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade login show" id="addressCheck" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body pr-4 pl-4 pb-4">
                <div class="mt-2">
                    <b>{{alertMessage}}</b>
                </div>

                <div class="row pt-4 pb-4">
                <div data-dismiss="modal" class="col-md-6 cCursorhover">
                    <a style="color:black;">OK</a>
                </div>
                <div data-dismiss="modal" class="col-md-6 cCursorhover">
                    <a href="" style="color:red;">Cancel</a>
                </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal bottom fade show" id="selectaddress" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog fixed-bottom m-0 mw-100 cAddaddress" role="document">
        <div class="modal-content select-address border-0">
            <div class="modal-header pt-0">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-md-12">
                        <span><img src="../assets/img/location/Icon awesome-map-marker-alt.svg" class="img-fluid mr-3 align-middle"></span><span><b class="align-middle">Select Delivery Address</b></span>
                    </div>
                    
                    <GmapMap
                    :center="center"
                    :zoom="18"
                    map-style-id="roadmap"
                    :options="mapOptions"
                    style="width: 500px; height: 300px"
                    ref="mapRef"
                    @click="handleMapClick"
                    >
                    <GmapMarker
                    :position="marker.position"
                    :clickable="true"
                    :draggable="true"
                    @drag="handleMarkerDrag"
                    @click="panToMarker"
                    />
                    </GmapMap>

                    <div class="col-md-12 address-font">
                        <span class="mb-0 text-muted"><b>YOUR LOCATION</b></span>
                    </div>
                    <div class="col-md-12 address-font mt-2">
                        <div class="row">
                            <div class="col-1 custom-text-color">
                                <i class="far fa-check-circle"></i>
                            </div>
                            <div class="col-11">
                                <span><b>{{formattedAddress}}</b></span>
                            </div>
                        </div>
                        <form>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <label class="custom-text-color"><b>Select City</b></label>
                                    <div class="input-group mb-2 mt-1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text prepend-background border-0">
                                                <img src="../assets/img/location/Vector (1).svg" class="img-fluid">
                                            </div>
                                        </div>
                                        
                                        <select id="store" @change="getLocalities($event)" class="form-control prepend-background border-0">
                                        <option v-for="city in cityList" :key="city.id" class="option-font-size" v-bind:value="city.CityID" :selected="city.CityName == selectedCityName">{{city.CityName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <label class="custom-text-color"><b>Select Locality</b></label>
                                    <div class="input-group mb-2 mt-1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text prepend-background border-0">
                                                <img src="../assets/img/location/Vector (2).svg" class="img-fluid">
                                            </div>
                                        </div>
                                         <select id="store" @change="localitySelected($event)" class="form-control prepend-background border-0">
                                        <option v-for="locality in localityList" :key="locality.id" class="option-font-size" v-bind:value="locality.LocalityID" :selected="locality.LocalityName == selectedLocalityName">{{locality.LocalityName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2 mb-2">
                                    <label class="custom-text-color mb-1"><b>House or Office Number</b></label>
                                    <input type="number" id="unitNo" class="form-control prepend-background border-0" v-on:keyup="validateHouseField($event)" name="phone_number" placeholder="House or Office Number" value=""/>
                                </div>
                                 <div class="errorMessage cCustommargin">
                                    {{HouseErrorMessage}}
                                </div>
                                <div class="col-md-12 mt-2 mb-2">
                                    <label class="custom-text-color mb-1"><b>Floor & Tower</b></label>
                                    <input type="text" id="floor" class="form-control prepend-background border-0" v-on:keyup="validateFloorField($event)" name="Floor_Tower" placeholder="Floor & Tower" value=""/>
                                </div>
                                 <div class="errorMessage cCustommargin">
                                    {{FloorErrorMessage}}
                                </div>
                                <div class="col-md-12 mt-2 mb-2">
                                    <label class="custom-text-color mb-1"><b>Building/Society</b></label>
                                    <input type="text" id="building" class="form-control prepend-background border-0" v-on:keyup="validateSocietyField($event)" name="Building_Society" placeholder="Building/Society" value=""/>
                                </div>
                                 <div class="errorMessage cCustommargin">
                                        {{SocietyErrorMessage}}
                                </div>
                                <div class="col-md-12 mt-2 mb-2">
                                    <label class="custom-text-color ,b-1"><b>How  to reach (optional)</b></label>
                                    <input type="text" id="reach" class="form-control prepend-background border-0" name="Building_Society" placeholder="How  to reach (optional)" value=""/>
                                </div>
                                <div class="col-md-12 mt-3 mb-3">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <b>Tag this location</b>
                                        </div>
                                        <div class="col-md-7 pl-0">
                                            <a class="text-dark mr-2 cCursorhover" v-for="tags in addressTagList"  :key="tags.id" v-bind:id="tags.TagName" @click="selectTag(tags.TagName)" ><b>{{tags.TagName}}</b></a>
                                            <!-- <a href="#" class="text-dark mr-2"><b>Other</b></a> -->
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </form>
                        <div class="col-md-12 mt-2 mb-2">
                                    <button type="submit" data-dismiss="modal" @click="submitAddress()" class="btn save-address-button btn-block">Save Address and Proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade login show" id="offersModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header pl-4">
                <h5 class="modal-title" id="exampleModalLabel">% Offers</h5>
                <button type="button" class="close" id="closeDelivery" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>

            <div class="modal-body">
        
            <div class="container-fluid">
                
                <div class="row promocode" v-for="item in items" :key="item.id">
                    
                    <!-- eslint-disable -->
                    <div class="col-md-12 col-lg-12 mb-5" v-for="offer in item[0].JSon3" :key="offer.id" v-if="offer.Context == 'OFFER'">
                    <!-- eslint-enable -->
                        <div class="card border-0 offer-box">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-3 pr-0 justify-content-center align-self-center">
                                        <!-- <img src="../assets/img/promocode/paytm.svg" class="img-fluid" alt="Responsive image"> -->
                                    </div>
                                    <div class="col-9 pr-0">
                                        <b>{{offer.header}}</b>
                                        <p class="mb-0 text-muted">{{offer.Description}}</p>
                                    </div>
                                    <div class="col-md-12">
                                        <hr />
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <p class="mb-2"><span class="flat-text">{{offer.CouponCode}}</span></p>
                                        
                                        <button type="button" data-dismiss="modal" @click="applyCoupon(offer.CouponCode)" class="btn cApplycoupon">APPLY</button>
                                    </div>
                                    <div class="col-md-12">
                                        <hr class="mt-0" />
                                    </div>
                                    <div class="col-md-12">
                                        <div class="text-center">
                                            <b class="custom-text-color" data-toggle="modal" data-target="#promocodeModal">{{offer.TermsOfUse}}</b>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        
            </div>

        </div>
    </div>
</div>

</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps,{
  load: {
    key: "AIzaSyCRNkCEhDvjxASZD11b_PRPZ45VVNdNQZ0",
    libraries:'places'
  },
});

export default {
  name: 'App',
  components:{
        Loading
    },
    computed:{
      items() {
        return this.$store.state.items
      }
    },
  data : function(){
      return {
          productsList : [],
          response : [],
          chargesList : [],
          bandList : [],
          deliveryInstruction : '',
          instructionBoolean : false,
          currencyText : sessionStorage.getItem('currency'),
          selectedList : [],
          isLoading: false,
          fullPage: true,
          loader:'Spinner',
          itemCount : 0,
          storeName : sessionStorage.getItem('StoreName'),
          address : sessionStorage.getItem('StoreAddress'),
          userContactNo : "",
          otpHandle : "",
          citizenHandle : "",
          citizenName : "",
          riderTipList:[],
          askTip : true,
          riderTip : '',
          phoneErrorMessage : "",
          verifyOtpBoolean : false,
          updateNameBoolean : false,
          successfullLogin:false,
          addressList : [],
          selected : false,
          marker: { position: { lat: 10, lng: 10 } },
          center: { lat: 10, lng: 10 },

          mapOptions: {
          disableDefaultUI: true,
          },
          formattedAddress : '',
          countryId : sessionStorage.getItem('countryId'),
          cityList : [],
          localityList : [],
          addressTagList : [],
          selectedCityId : '',
          selectedCityName : '',
          selectedLocalityId : '',
          selectedLocalityName : '',
          selectedTag : 'Home',
          editable : false,
          editAddressHandle : '',
          selectedAddress : '',
          countryList : [],
          countryCode : '',
          phoneMaxLength : 10,
          OtpErrorMessage : '',
          resend : false,
          countdown : 10,
          NameErrorMessage : '',
          emailErrorMessage : '',
          emailSuccess : false,
          EmailOtpErrorMessage : '',
          addressHandleSelected : '',
          UserImgUrl : '',
          HouseErrorMessage : '',
          FloorErrorMessage : '',
          SocietyErrorMessage : '',
          easyCommerce : sessionStorage.getItem('ECommDS'),
          fullCommerceProductList : [],
          tempDeliveryDate : 'Today',
          tempdeliveryTime : 'ASAP',
          deliverydetails : '',
          deliveryDate : '',
          deliveryTime : '',
          showDeliveryBlock: sessionStorage.getItem('DeliveryType'),
          txnHandle : '',
          deliveryMode : 'D',
          deliveryTimeText : 'Delivery Time',
          couponCode : '',
          today : '',
          alertMessage : 'Are you sure you want to logout?',
          dummyProductList : []
      }
  },
    mounted(){
        window.scroll(0,0)
        this.today = new Date().toISOString().split('T')[0]
        this.geolocate();
        if(sessionStorage.getItem('LoginToken') != null){
            this.citizenHandle = sessionStorage.getItem('citizenHandle')
            console.log(this.citizenHandle)
            this.fetchProfile();
            this.BuyerManagement();
            
        }
        this.getCountryCodes();
        this.getRidersTip();
     this.response = JSON.parse(sessionStorage.getItem('submitCart'))
     this.productsList = this.response.JSon0
     for(var i=0;i<this.response.JSon3.length;i++){
         this.productsList.push(this.response.JSon3[i])
     }
     for(var j=0;j<this.response.JSon4.length;j++){
         this.productsList.push(this.response.JSon4[j])
     }
     console.log(this.productsList)
     this.dummyProductList = JSON.parse(sessionStorage.getItem(this.$route.params.handle))
     this.fullCommerceProductList = JSON.parse(sessionStorage.getItem(this.$route.params.handle))
     this.chargesList = this.response.JSon1
     this.bandList = this.response.JSon2
     this.itemCount = this.productsList.length

    this.deliverydetails = JSON.parse(sessionStorage.getItem('DeliveryDetails'))
    this.deliveryDate = this.deliverydetails.deliveryDate
    this.deliveryTime = this.deliverydetails.deliveryTime
    console.log(this.deliverydetails)

     if(sessionStorage.getItem(this.$route.params.handle + ' Instruction') != null){
         if(sessionStorage.getItem(this.$route.params.handle + ' Instruction') != ''){
        this.deliveryInstruction = sessionStorage.getItem(this.$route.params.handle + ' Instruction')
        this.instructionBoolean = true;
    }
    else{
        this.deliveryInstruction = '';
        this.instructionBoolean = false
    }
     }
     else{
          this.deliveryInstruction = '';
        this.instructionBoolean = false
     }

     if(sessionStorage.getItem('DeliveryType') == 'home' || sessionStorage.getItem('DeliveryType') == 'home1'){
                this.deliveryTimeText = 'Delivery Time'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'takeAway' || sessionStorage.getItem('DeliveryType') == 'takeAway1'){
                this.deliveryTimeText = 'Take-out Time'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'dineIn' || sessionStorage.getItem('DeliveryType') == 'dineIn1'){
                this.deliveryTimeText = 'DineIn Time'
            }
    
    },
    methods: {
        saveInstruction: function(){
           if(document.getElementById('instructionValue').value == ''){
               this.instructionBoolean = false
           }
           else{
               this.instructionBoolean = true
               this.deliveryInstruction = document.getElementById('instructionValue').value
               sessionStorage.setItem(this.$route.params.handle + ' Instruction',this.deliveryInstruction)
           }

           this.submitCart();
        },
        loginWithFacebook () {
            window.FB.login(response => {
            console.log('fb response', response)
            }, this.params)
            
        },
        changeEditable: function(){
            this.editable = false
        document.getElementById('unitNo').value = '';
        document.getElementById('floor').value = '';
        document.getElementById('building').value = '';
        document.getElementById('reach').value = "";
        this.selectedCityName = '';
        this.selectedLocalityName = '';
        this.localityList = [];
        this.geolocate();
        
        },
        geolocate() {
        navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          
        };
        this.getGeoAddress();
        this.panToMarker();
        
      });
     this.getCitiesForCountry();
     this.getAddressTags();
    },

    backToProducts: function(){
        this.$router.go(-1)
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };

        this.getGeoAddress();
    },
    movetoOtp2: function(){
         $("#otp-2").focus();
    },
    movetoOtp3: function(){
         $("#otp-3").focus();
    },movetoOtp4: function(){
         $("#otp-4").focus();
    },
    movetoOtp10: function(){
         $("#otp-10").focus();
    },
    movetoOtp11: function(){
         $("#otp-11").focus();
    },movetoOtp12: function(){
         $("#otp-12").focus();
    },
    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
    //   this.$refs.mapRef.setZoom(10);

      
    },

    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.getGeoAddress();
      this.getCitiesForCountry();
    },
    getGeoAddress: function(){
        axios
                .get('https://maps.googleapis.com/maps/api/geocode/json',
                {
                params:{
                    'latlng' : this.marker.position.lat + "," + this.marker.position.lng,
                    'key':'AIzaSyCRNkCEhDvjxASZD11b_PRPZ45VVNdNQZ0'
                }
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                    }
                })
                .then((response) =>{
                this.formattedAddress = response.data.results[0].formatted_address
                if(!this.editable){
                    this.selectedCityName = response.data.results[0].address_components[3].long_name
                }
            })
            .catch(() =>{
                
                })
    },
    validateHouseField: function(event){
        const mailRegex = /^[0-9 ]+$/;
            if(!mailRegex.test(event.target.value)){
                 this.HouseErrorMessage = "Please Enter Valid House or Office Number"
                    return;
            }
            else{
                this.HouseErrorMessage= "";
            }
    },
    Datepicker: function(event){
        console.log(event.target.value)
        this.tempDeliveryDate = event.target.value
    },
    Timepicker: function(event){
        this.tempdeliveryTime = event.target.value
    },
    confirmDeliveryTime: function(){
        this.deliveryDate = this.tempDeliveryDate;
        this.deliveryTime = this.tempdeliveryTime;
    },
    validateFloorField: function(event){
        const mailRegex = /^[0-9A-Za-z ]+$/;
            if(!mailRegex.test(event.target.value)){
                 this.FloorErrorMessage = "Please Enter Valid Floor & Tower"
                    return;
            }
            else{
                this.FloorErrorMessage= "";
            }
    },
    validateSocietyField: function(event){
        const mailRegex = /^[0-9A-Za-z ]+$/;
            if(!mailRegex.test(event.target.value)){
                 this.SocietyErrorMessage = "Please Enter Valid Building/Society"
                    return;
            }
            else{
                this.SocietyErrorMessage= "";
            }
    },
    validatePhone: function(event){
        const mailRegex = /^[0-9]+$/;
            if(!mailRegex.test(event.target.value)){
                 this.phoneErrorMessage = "Please enter valid phone number"
                    return;
            }
            else{
                this.phoneErrorMessage= "";
            }

        if(event.target.value.length != this.phoneMaxLength){
                this.phoneErrorMessage = "Please enter valid phone number"
        }
        else{
            this.phoneErrorMessage = ""
        }
    },
    
    changeAddress: function(){
        this.selected = false
        this.addressHandleSelected = ''
    },
    resendEmailOtp: function(){
        document.getElementById('otp-9').value = '';
        document.getElementById('otp-10').value = '';
        document.getElementById('otp-11').value = ''; 
        document.getElementById('otp-12').value = '';
    },
    resendOtp: function(){
        this.resend = true;
        document.getElementById('otp-1').value = '';
        document.getElementById('otp-2').value = '';
        document.getElementById('otp-3').value = ''; 
        document.getElementById('otp-4').value = '';

        if(this.countdown > 0){
            setTimeout(() => {
                this.countdown -=1
                this.resendOtp();
            },1000)
        }
        else{
            this.countdown = 10;
            this.resend = false;
        }
    },
    getCitiesForCountry(){
        axios
                .post('https://entityserver.manikworks.com/apputils',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Context':'GET.CITIES.FOR.COUNTRY',
                        'Content-Type':'application/json',
                        'QueryFilter':this.countryId,
                        'Latitude': this.marker.position.lat,
                        'Longitude': this.marker.position.lng

                    }
                })
                .then((response) =>{
                    if(this.editable == false){
                        this.selectedCityName = response.data.ManikJSon[0].JSon0[0].CityName
                    }
                    this.cityList = response.data.ManikJSon[0].JSon0
                    console.log(this.selectedCityName)
            })
            .catch(() =>{
                
                })
    },

    fetchProfile: function(){

        let items = [
            {
            'CitizenHandle':this.citizenHandle
            }
        ]

        axios
                .post('https://entityserver.manikworks.com/citizenship',
                 {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation':'GET.PROFILE',
                        'Content-Type':'application/json',
                    }
                })
                .then((response) =>{
                   console.log(response)
                   this.successfullLogin = true
                   this.citizenName = response.data.ManikJSon[0].JSon0[0].CitizenName
                   this.userContactNo = response.data.ManikJSon[0].JSon0[0].MobileNumber
                   this.MobileNumberLength = response.data.ManikJSon[0].JSon0[0].MobileNumberLength
                   this.UserImgUrl = response.data.ManikJSon[0].JSon0[0].ImageURL
                   this.$root.$emit('loginBoolean',this.citizenName,this.UserImgUrl)
                   this.getSavedAdresses()
            })
            .catch(() =>{
                
                })
    },
    localitySelected: function(event){
        this.selectedLocalityId = event.target.value
         for(var i=0;i<this.localityList.length;i++){
            if(this.localityList[i].LocalityID == event.target.value){
                this.selectedLocalityName = this.localityList[i].LocalityName
            }
         }
    },
    getCountryDetails: function(event){
        this.countryCode = event.target.value
        for(var i=0;i<this.countryList.length;i++){
            if(this.countryList[i].CountryCode == this.countryCode){
                this.phoneMaxLength = this.countryList[i].MobileNumberLength
            }
        }
    },
    getCountryCodes: function(){
         axios
                .post('https://entityserver.manikworks.com/apputils',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Context':'GET.COUNTRY.AND.LANGUAGE',
                        'Content-Type':'application/json',
                    }
                })
                .then((response) =>{
                  
                    this.countryList = response.data.ManikJSon[0].JSon0
                    this.countryCode = this.countryList[0].CountryCode
                    this.phoneMaxLength = this.countryList[0].MobileNumberLength
            })
            .catch(() =>{
                
                })
    },
    getLocalities: function(event){
        this.selectedCityId = event.target.value
        for(var i=0;i<this.cityList.length;i++){
            if(this.cityList[i].CityID == event.target.value){
                this.selectedCityName = this.cityList[i].CityName
            }
        }
        axios
                .post('https://entityserver.manikworks.com/apputils',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Context':'GET.LOCALITIES.FOR.A.CITY',
                        'Content-Type':'application/json',
                        'QueryFilter':event.target.value,
                        'Latitude': this.marker.position.lat,
                        'Longitude': this.marker.position.lng

                    }
                })
                .then((response) =>{
                    console.log(response)
                    this.localityList = response.data.ManikJSon[0].JSon0
                    this.selectedLocalityName = this.localityList[0].LocalityName
            })
            .catch(() =>{
                
                })
    },

    getAddressTags: function(){
        axios
                .post('https://entityserver.manikworks.com/buyermgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType':'FETCH.ADDRESS.TAGS',
                        'LGContext':sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                    }
                })
                .then((response) =>{
                    
                    this.addressTagList = response.data.ManikJSon[0].JSon0
            })
            .catch(() =>{
                
                })
    },

    EditAddress: function(address){
        console.log(address)
        this.editable = true;
        this.selectedCityName = address.CityName
        this.getCitiesForCountry();
        document.getElementById('unitNo').value = address.UnitNo
        document.getElementById('floor').value = address.FloorAndTower
        document.getElementById('building').value = address.BuildingOrSociety
        document.getElementById('reach').value = "";
        this.editAddressHandle = address.AddressHandle; 
        // for(var i=0;i<this.addressTagList.length;i++){
        //     if(this.addressTagList[i].TagName == address.AddressTag){
        //         document.getElementById(address.AddressTag).classList.add('active-location')
        //     }
        //     else{
        //         document.getElementById(address.AddressTag).classList.remove('active-location')
        //         document.getElementById(address.AddressTag).classList.add('text-dark')
        //     }
        // }
        this.formattedAddress = address.DeliveryAddress
        this.selectedCityId = address.DeliveryCityID
        this.selectedLocalityId = address.DeliveryLocalityID
          axios
                .post('https://entityserver.manikworks.com/apputils',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Context':'GET.LOCALITIES.FOR.A.CITY',
                        'Content-Type':'application/json',
                        'QueryFilter':address.DeliveryCityID,
                        'Latitude': address.Latitude,
                        'Longitude': address.Longitude

                    }
                })
                .then((response) =>{
                    this.selectedLocalityName = address.Locality
                    this.localityList = response.data.ManikJSon[0].JSon0
            })
            .catch(() =>{
                
                })
        this.geolocate();
        this.marker.position = {
          lat: address.Latitude,
          lng: address.Longitude,
        };

        this.getGeoAddress();
    },

    DeleteAddress: function(address){
        this.isLoading = true
        axios
                .post('https://entityserver.manikworks.com/buyermgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType':'DELETE.BUYER.ADDRESS',
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                        'CitizenHandle': this.citizenHandle,
                        'AddressHandle':address.AddressHandle
                    }
                })
                .then((response) =>{
                    console.log(response)
                    this.getSavedAdresses();
                    this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false

                })
    },
        minus: function(product){
            product.Q = product.Q - 1;
            console.log(product)
            console.log(this.dummyProductList)
            for(var i=0;i<this.dummyProductList.length;i++){
                    if(this.dummyProductList[i].productHandle == product.PH){
                        this.dummyProductList[i].quantity = this.dummyProductList[i].quantity - 1;
                    }
            }
            if(product.Q == 0){
                const index = this.productsList.indexOf(product);
                this.productsList.splice(index,1)
                for(var j=0;j<this.dummyProductList.length;j++){
                    if(this.dummyProductList[j].productHandle == product.PH){
                        console.log(product.ProductName)
                        const index = this.dummyProductList.indexOf(this.dummyProductList[j]);
                        this.dummyProductList.splice(index,1)
                    }
                }
                
            }
            sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.dummyProductList))
                if(this.dummyProductList.length == 0){
                    sessionStorage.removeItem(this.$route.params.handle)
                }
            this.submitCart();
        },
        add: function(product){
            product.Q = product.Q + 1;
            for(var i=0;i<this.dummyProductList.length;i++){
                    if(this.dummyProductList[i].productHandle == product.PH){
                        this.dummyProductList[i].quantity = this.dummyProductList[i].quantity + 1;
                    }
            }
            sessionStorage.setItem(this.$route.params.handle,JSON.stringify(this.dummyProductList))
            this.submitCart();
        },
        viewOffers: function(){
            this.$router.push({name:'offers'})
        },
        submitOtp: function(){
            this.userContactNo = document.getElementById('contact').value;
            this.verifyOtpBoolean = false
            const mailRegex = /^[0-9]+$/;
            if(!mailRegex.test(this.userContactNo)){
                console.log(this.userContactNo)
                 this.phoneErrorMessage = "Please enter valid phone number"
                    return;
            }
            else{
                this.phoneErrorMessage= "";
            }

            if(this.userContactNo.length != this.phoneMaxLength){
                this.phoneErrorMessage = "Please enter valid phone number"
                return
                }
            else{
            this.phoneErrorMessage = ""
            }
            this.verifyOtpBoolean = true
            this.phoneErrorMessage =""
            this.isLoading = true
            let items = [
            {
            "CountryCode": this.countryCode,
             "MobileNumber": this.userContactNo,
             "LanguageID": "100000",
             "CountryID": this.countryId
            }
        ]
            

                  axios
                .post('https://entityserver.manikworks.com/citizenship',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'LOGIN.BY.MOBILE',
                        'Content-Type': 'application/json',
                        'AuthChannel': 'M',
                        'SignUpSource': 'A',
                        'PortalContext': 'EMCITY',
                    }
                })
                .then((response) =>{
                this.otpHandle = response.data.ManikJSon[0].JSon0[0].OTPHandle
                this.citizenHandle = response.data.ManikJSon[0].JSon1[0].CitizenHandle
                var closePhone = document.getElementById("phoneLogin")
                closePhone.click()
                if(response.data.ManikJSon[0].JSon1[0].Status == 'EXISTS'){
                this.citizenName = response.data.ManikJSon[0].JSon1[0].CitizenName
                console.log(this.citizenHandle)
                }
                this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        validateEmail: function(event){
             const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!mailRegex.test(event.target.value)){
                this.emailErrorMessage = 'Please enter valid Email'
            }
            else{
                this.emailErrorMessage= "";
            }
        },
        applyCoupon: function(code){
            console.log(code)
            this.couponCode = code
            this.submitCart()
        },
        SendOtpToMail(){
            this.emailSuccess = false
            var mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!mailRegex.test(document.getElementById('emailId').value)){
                this.emailErrorMessage = 'Please enter valid Email'
                return
            }
            this.isLoading = true
            this.emailSuccess = true
            let items = [
            {
            "EmailID": document.getElementById('emailId').value,
             "LanguageID": "100000",
             "CountryID": this.countryId
 
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/citizenship',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'LOGIN.BY.EMAIL',
                        'Content-Type': 'application/json',
                        'AuthChannel': 'E',
                        'SignUpSource': 'A',
                        'PortalContext': 'EMCITY',
                    }
                })
                .then((response) =>{
                this.otpHandle = response.data.ManikJSon[0].JSon0[0].OTPHandle
                this.citizenHandle = response.data.ManikJSon[0].JSon1[0].CitizenHandle
                if(response.data.ManikJSon[0].JSon1[0].Status == 'EXISTS'){
                this.citizenName = response.data.ManikJSon[0].JSon1[0].CitizenName
                }
                this.userContactNo = document.getElementById('emailId').value
                var closeEmail = document.getElementById("closeEmail")
                closeEmail.click()
                this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        validateName: function(event){
            if(event.target.value == ''){
                 this.NameErrorMessage = "Name is mandatory"
            }
            else{
                 this.NameErrorMessage = ""
            }
        },
        updateName: function(){
            if(document.getElementById('username').value == ''){
                this.NameErrorMessage = "Name is mandatory"
                return;
            }
            this.isLoading = true
             let items = [
            {
            "CitizenName": document.getElementById('username').value,
             "CitizenHandle": this.citizenHandle
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/citizenship',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'UPDATE.NAME',
                        'Content-Type': 'application/json',
                        'PortalContext': 'EMCITY',
                    }
                })
                .then((response) =>{
                    console.log(response)
                this.citizenName = document.getElementById('username').value
                const el = document.getElementById('closeName')
                el.click()
                this.isLoading = false
                this.fetchProfile();
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        submitAddress: function(){
            this.isLoading = true
            
            if(!this.editable){
                let items = [
            {
            "CitizenHandle": this.citizenHandle,
            "CountryID": this.countryId,
            "StoreHandle": sessionStorage.getItem('storeHandle'),
            "CapturedAddress": this.formattedAddress,
            "UnitNo": document.getElementById('unitNo').value,
            "FloorAndTower": document.getElementById('floor').value,
            "BuildingOrSociety": document.getElementById('building').value,
            "Landmark": "",
            "AddressTag": this.selectedTag,
            "AddlDetails": document.getElementById('reach').value,
            "Locality": this.selectedLocalityName,
            "CityName": this.selectedCityName,
            "CountryName": "India",
            "Latitude": String(this.marker.position.lat),
            "Longitude": String(this.marker.position.lng),
            "DeliveryLocalityID": this.selectedLocalityId,
            "DeliveryCityID": this.selectedCityId
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/buyermgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'ADD.BUYER.ADDRESS',
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                    }
                })
                .then((response) =>{
                    console.log(response)
                            this.getSavedAdresses();
                            this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false;
                })
            }

            if(this.editable){
                let items = [
            {
            "AddressHandle": this.editAddressHandle,
            "CountryID": this.countryId,
            "CitizenHandle": this.citizenHandle,
            "StoreHandle": sessionStorage.getItem('storeHandle'),
            "CapturedAddress": this.formattedAddress,
            "UnitNo": document.getElementById('unitNo').value,
            "FloorAndTower": document.getElementById('floor').value,
            "BuildingOrSociety": document.getElementById('building').value,
            "Landmark": "",
            "AddressTag": this.selectedTag,
            "AddlDetails": document.getElementById('reach').value,
            "Locality": this.selectedLocalityName,
            "CityName": this.selectedCityName,
            "CountryName": "India",
            "Latitude": String(this.marker.position.lat),
            "Longitude": String(this.marker.position.lng),
            "DeliveryLocalityID": this.selectedLocalityId,
            "DeliveryCityID": this.selectedCityId
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/buyermgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'EDIT.BUYER.ADDRESS',
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                    }
                })
                .then((response) =>{
                    console.log(response)
                            this.getSavedAdresses();
                            this.isLoading = false
            })
            .catch(() =>{
                    this.isLoading = false;
                })
            }              
        },
        getSavedAdresses: function(){
                
              axios
                .post('https://entityserver.manikworks.com/buyermgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'FETCH.ALL.BUYER.ADDRESS',
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                        'CitizenHandle': this.citizenHandle,
                        'Latitude': this.marker.position.lat,
                        'Longitude': this.marker.position.lng,
                        'Radius': sessionStorage.getItem('radius')
                    }
                })
                .then((response) =>{
                   console.log(response)
                   this.addressList = [];
                    if(response.data.ManikJSon[0].JSon1 != null){
                        for(var j=0; j<response.data.ManikJSon[0].JSon1.length;j++){
                            if(response.data.ManikJSon[0].JSon1[j].AddressHandle != null){
                                console.log("JSON1 CALLED")
                                this.addressList.push(response.data.ManikJSon[0].JSon1[j])
                            }
                            
                        }
                    }
                    if(response.data.ManikJSon[0].JSon0 != null){
                        for(var i=0; i<response.data.ManikJSon[0].JSon0.length;i++){
                            if(response.data.ManikJSon[0].JSon0[i].AddressHandle != null){
                                console.log("JSON0 CALLED")
                                this.addressList.push(response.data.ManikJSon[0].JSon0[i])
                            }
                            
                        }
                    }
                    console.log(this.addressList)
                })
                .catch(() =>{
                    this.isLoading = false;
                })
        },
        validateEmailOtp: function(){
            if((document.getElementById('otp-9').value + document.getElementById('otp-10').value
             + document.getElementById('otp-11').value + document.getElementById('otp-12').value).length != 4){
                 this.EmailOtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.EmailOtpErrorMessage = ""
             }
        },

        validateOtp: function(){
             if((document.getElementById('otp-1').value + document.getElementById('otp-2').value
             + document.getElementById('otp-3').value + document.getElementById('otp-4').value).length != 4){
                 this.OtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.OtpErrorMessage = ""
             }
        },

        verifyOtp: function(){
            if((document.getElementById('otp-1').value + document.getElementById('otp-2').value
             + document.getElementById('otp-3').value + document.getElementById('otp-4').value).length != 4){
                 this.OtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.OtpErrorMessage = ""
             }
            
                  axios
                .post('https://entityserver.manikworks.com/citizenship',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'VERIFY.OTP',
                        'OTPHandle': this.otpHandle,
                        'EnteredOTP': document.getElementById('otp-1').value + document.getElementById('otp-2').value + document.getElementById('otp-3').value + document.getElementById('otp-4').value,
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>{
                    console.log(response)
                    
                    this.successfullLogin = true
                    if(this.citizenHandle == this.userContactNo){
                        this.citizenHandle = response.data.ManikJSon[0].JSon1[0].CitizenHandle
                    }

                sessionStorage.setItem('LoginToken',response.data.ManikJSon[0].JSon0[0].JWT)
                sessionStorage.setItem('citizenHandle',this.citizenHandle)
                sessionStorage.setItem('Token',response.data.ManikJSon[0].JSon0[0].JWT)
                if(response.data.ManikJSon[0].JSon2[0].Name == "INCOMPLETE"){
                    var closePhone = document.getElementById("phoneLogin")
                    closePhone.click()
                    var closeOtp = document.getElementById("otpClose")
                    closeOtp.click()
                    var openModel = document.getElementById('verifyOtp')
                    openModel.setAttribute('data-toggle','modal')
                    openModel.setAttribute('data-target','#login-name')
                    openModel.click();
                    
                }
                else if(response.data.ManikJSon[0].JSon2[0].Name == "COMPLETE"){
                    var closePhoneComp = document.getElementById("phoneLogin")
                    closePhoneComp.click()
                    var closeOtpComp = document.getElementById("otpClose")
                    closeOtpComp.click()
                    var openModelComp = document.getElementById('verifyOtp')
                    openModelComp.removeAttribute('data-toggle')
                    openModelComp.removeAttribute('data-target')
                    openModelComp.click();
                }
                this.geolocate();
                this.BuyerManagement();
                this.fetchProfile();
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },
        verifyEmailOtp: function(){
            if((document.getElementById('otp-9').value + document.getElementById('otp-10').value
             + document.getElementById('otp-11').value + document.getElementById('otp-12').value).length != 4){
                 this.EmailOtpErrorMessage = "Please enter valid Otp"
                 return
             }
             else{
                 this.EmailOtpErrorMessage = ""
             }
              axios
                .post('https://entityserver.manikworks.com/citizenship',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Operation': 'VERIFY.OTP',
                        'OTPHandle': this.otpHandle,
                        'EnteredOTP': document.getElementById('otp-9').value + document.getElementById('otp-10').value + document.getElementById('otp-11').value + document.getElementById('otp-12').value,
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>{this.successfullLogin = true
                sessionStorage.setItem('LoginToken',response.data.ManikJSon[0].JSon0[0].JWT)
                sessionStorage.setItem('citizenHandle',this.citizenHandle)
                sessionStorage.setItem('Token',response.data.ManikJSon[0].JSon0[0].JWT)
                if(response.data.ManikJSon[0].JSon2[0].Name == "INCOMPLETE"){
                    var closeEmail = document.getElementById("closeEmail")
                    closeEmail.click()
                    var closeEmailOtp = document.getElementById("closeEmailOtp")
                    closeEmailOtp.click()
                    var openModel = document.getElementById('verifyEmail')
                    openModel.setAttribute('data-toggle','modal')
                    openModel.setAttribute('data-target','#login-name')
                    openModel.click();
                    
                }
                else if(response.data.ManikJSon[0].JSon2[0].Name == "COMPLETE"){
                    var closeEmailComp = document.getElementById("closeEmail")
                    closeEmailComp.click()
                    var closeEmailOtpComp = document.getElementById("closeEmailOtp")
                    closeEmailOtpComp.click()
                    var openModelComp = document.getElementById('verifyEmail')
                    openModelComp.removeAttribute('data-toggle')
                    openModelComp.removeAttribute('data-target')
                    openModelComp.click();
                }
                this.geolocate();
                this.BuyerManagement();
                this.fetchProfile();
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },

        BuyerManagement: function(){
             axios
                .post('https://entityserver.manikworks.com/buyermgr',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'MANAGE.BUYER',
                        'BusinessHandle': sessionStorage.getItem('BusinessHandle'),
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'PortalDS': sessionStorage.getItem('PortalDS'),
                        'CitizenHandle': this.citizenHandle,
                    }
                })
                .then((response) =>{
                    console.log(response)
                })
                .catch(() =>{
                })
        },

        submitCart: function(){
             this.isLoading = true;
             console.log(this.fullCommerceProductList)
            const uniqueId = this.$route.params.handle + "-" + Math.random().toString(36).slice(2)
            const batchHandle = new Date().getTime()
            const submitItemsList = [];
            if(this.easyCommerce == 'ECOMM2' || this.easyCommerce == 'ecomm2'){
                for(var i=0;i<this.productsList.length;i++){
                for(var k=0;k<this.fullCommerceProductList.length;k++){
                    if(this.fullCommerceProductList[k].name == this.productsList[i].ProductName){
                        submitItemsList.push({SN:this.productsList[i].SN,BH:this.productsList[i].BH,PH:this.productsList[i].PH,PLID:this.productsList[i].PLID,Q:this.productsList[i].Q,Variants:this.fullCommerceProductList[k].variantList})
                    }
                }
                
            }
            }
            else{
                for(var j=0;j<this.productsList.length;j++){
                submitItemsList.push({SN:this.productsList[j].SN,BH:this.productsList[j].BH,PH:this.productsList[j].PH,PLID:this.productsList[j].PLID,Q:this.productsList[j].Q,VID:this.productsList[j].VID})
            }
            }

            if(sessionStorage.getItem('DeliveryType') == 'home' || sessionStorage.getItem('DeliveryType') == 'home1'){
                this.deliveryMode = 'D'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'takeAway' || sessionStorage.getItem('DeliveryType') == 'takeAway1'){
                this.deliveryMode = 'P'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'dineIn' || sessionStorage.getItem('DeliveryType') == 'dineIn1'){
                this.deliveryMode = 'I'
            }
            

           let items = [
            {
                "CartSummary": [
                {
                    "CartHandle": uniqueId,
                    "BranchHandle": sessionStorage.getItem('handle'),
                    "StoreHandle": sessionStorage.getItem('storeHandle'),
                    "Channel": "O",
                    "CitizenHandle": "f49e996e-35ea-4cf6-b15f-628e15301058",
                    "AddressHandle": "356d3bb3-690a-414f-931c-36cc666e4c7b",
                    "BatchHandle": batchHandle,
                    "Remarks": this.deliveryInstruction,
                    "DiscountCode": this.couponCode,
                    "DeliveryMode": this.deliveryMode,
                    "LanguageID": 100000,
                    "Tip": this.riderTip,
                    "DeliveryDate":this.deliveryDate,
                    "DeliveryTime":this.deliveryTime
                }
            ],
            "CartItems": submitItemsList,
            
            }
        ]
        axios
                .post('https://entityserver.manikworks.com/cartmgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'POST.CART',
                        'ECommDS': sessionStorage.getItem('ECommDS'),
                        'ECommPlan': sessionStorage.getItem('ECommPlan'),
                    }
                })
                .then((response) =>{
                                    sessionStorage.setItem('submitCart',JSON.stringify(response.data.ManikJSon[0]))
                                    this.productsList = [];
                                    this.chargesList = [];
                                    this.bandList = [];
                                    this.productsList = response.data.ManikJSon[0].JSon0
                                    this.chargesList = response.data.ManikJSon[0].JSon1
                                    this.bandList = response.data.ManikJSon[0].JSon2
                                    this.itemCount = this.productsList.length
                                    this.isLoading = false
                })
                .catch(() =>{
                    this.isLoading = false;
                })
        },

        getRidersTip: function(){
            this.isLoading = true
              axios
                .post('https://entityserver.manikworks.com/checkout',null,
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'RIDER.TIP.OPTIONS.FOR.COUNTRY',
                        'QueryFilter': 'RESTAURANT_100000',
                        'Content-Type': 'application/json',
                    }
                })
                .then((response) =>{
                if(response.data.ManikJSon[0].JSon0[0].AskTip == 'Y'){
                    this.riderTipList = (response.data.ManikJSon[0].JSon0[0].TipOptions).split(",")
                     this.isLoading = false
                }
                else{
                    this.askTip = false;
                    this.isLoading = false
                }
                
            })
            .catch(() =>{
                    this.isLoading = false;
                })
        },

        addTip: function(tip){
            if(document.getElementById(tip).classList.contains('active-tip')){
                document.getElementById(tip).classList.remove('active-tip')
                this.riderTip = '';
                this.submitCart();
            }
            else{
                document.getElementById(tip).classList.add('active-tip')
                this.riderTip = tip;
                this.submitCart();
            }
            
            for(var i=0;i<this.riderTipList.length;i++){
                if(this.riderTipList[i] != tip){
                    document.getElementById(this.riderTipList[i]).classList.remove('active-tip')
                }
            }
        },

        selectAddress: function(address){
            this.selected = true
            this.selectedAddress = address;
            this.addressHandleSelected = address.AddressHandle
            console.log(address)
                let items = [
            {
            "AddressHandle": address.AddressHandle,
            "CountryID": this.countryId,
            "CitizenHandle": this.citizenHandle,
            "StoreHandle": sessionStorage.getItem('storeHandle'),
            "CapturedAddress": address.DeliveryAddress,
            "UnitNo": address.UnitNo,
            "FloorAndTower": address.FloorAndTower,
            "BuildingOrSociety": address.BuildingOrSociety,
            "Landmark": "",
            "AddressTag": address.AddressTag,
            "AddlDetails": "",
            "Locality": address.Locality,
            "CityName": address.CityName,
            "CountryName": "India",
            "Latitude": String(this.marker.position.lat),
            "Longitude": String(this.marker.position.lng),
            "DeliveryLocalityID": address.DeliveryLocalityID,
            "DeliveryCityID": address.DeliveryCityID
            }
        ]
                  axios
                .post('https://entityserver.manikworks.com/buyermgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'EDIT.BUYER.ADDRESS',
                        'LGContext': sessionStorage.getItem('LgContext'),
                        'ECommServer': sessionStorage.getItem('ECommDS'),
                    }
                })
                .then((response) =>{
                    console.log(response)
            })
            .catch(() =>{
                })
        },
        selectTag: function(tags){
            if(document.getElementById(tags).classList.contains('active-location')){
                document.getElementById(tags).classList.remove('active-location')
                this.selectedTag = '';
            }
            else{
                document.getElementById(tags).classList.add('active-location')
                this.selectedTag = tags;
            }
            
            for(var i=0;i<this.addressTagList.length;i++){
                if(this.addressTagList[i].TagName != tags){
                    document.getElementById(this.addressTagList[i].TagName).classList.remove('active-location')
                    document.getElementById(this.addressTagList[i].TagName).classList.add('text-dark');
                }
            }

        },

        ScheduleDelivery: function(){
            var closeDeliveryComp = document.getElementById("closeDelivery")
            closeDeliveryComp.click()
        },

        BackToImmediate: function(){
            var closeDeliveryComp = document.getElementById("closeScheduleLaterModel")
            closeDeliveryComp.click()
        },

        payNow: function(){
            if(this.citizenHandle == ''){
                var loginOrSignUp = document.getElementById("loginOrSignUp")
                loginOrSignUp.click()
                return
            }
            if(this.addressHandleSelected == '' && (sessionStorage.getItem('DeliveryType') == 'home' || sessionStorage.getItem('DeliveryType') == 'home1')){
                this.alertMessage = 'Please select address to proceed'
                var notYou = document.getElementById("notYou")
                notYou.click()
                return
            }
            this.isLoading = true
           
            const uniqueId = this.$route.params.handle + "-" + Math.random().toString(36).slice(2)
            const batchHandle = new Date().getTime()
            const submitItemsList = [];

            if(this.easyCommerce == 'ECOMM2' || this.easyCommerce == 'ecomm2'){
                for(var i=0;i<this.productsList.length;i++){
                for(var k=0;k<this.fullCommerceProductList.length;k++){
                    if(this.fullCommerceProductList[k].name == this.productsList[i].ProductName){
                        submitItemsList.push({SN:this.productsList[i].SN,BH:this.productsList[i].BH,PH:this.productsList[i].PH,PLID:this.productsList[i].PLID,Q:this.productsList[i].Q,Variants:this.fullCommerceProductList[k].variantList})
                    }
                }
                
            }
            }
            else{
                for(var j=0;j<this.productsList.length;j++){
                submitItemsList.push({SN:this.productsList[j].SN,BH:this.productsList[j].BH,PH:this.productsList[j].PH,PLID:this.productsList[j].PLID,Q:this.productsList[j].Q,VID:this.productsList[j].VID})
            }
            }

            if(sessionStorage.getItem('DeliveryType') == 'home' || sessionStorage.getItem('DeliveryType') == 'home1'){
                this.deliveryMode = 'D'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'takeAway' || sessionStorage.getItem('DeliveryType') == 'takeAway1'){
                this.deliveryMode = 'P'
            }
            else if(sessionStorage.getItem('DeliveryType') == 'dineIn' || sessionStorage.getItem('DeliveryType') == 'dineIn1'){
                this.deliveryMode = 'I'
            }

        if(submitItemsList != []){
            let items = [
            {
                "CartSummary": [
                {
                    "CartHandle": uniqueId,
                    "BranchHandle": sessionStorage.getItem('handle'),
                    "StoreHandle": sessionStorage.getItem('storeHandle'),
                    "Channel": "O",
                    "CitizenHandle": this.citizenHandle,
                    "AddressHandle": this.addressHandleSelected,
                    "BatchHandle": batchHandle,
                    "Remarks": this.deliveryInstruction,
                    "DiscountCode": this.couponCode,
                    "DeliveryMode": this.deliveryMode,
                    "LanguageID": 100000,
                    "Tip": this.riderTip,
                    "DeliveryDate":this.deliveryDate,
                    "DeliveryTime":this.deliveryTime
                }
            ],
            "CartItems": submitItemsList,
            
            }
        ]
        axios
                .post('https://entityserver.manikworks.com/cartmgr',
                {
                items
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'EntityActionType': 'CREATE.ORDER',
                        'ECommDS': sessionStorage.getItem('ECommDS'),
                        'ECommPlan': sessionStorage.getItem('ECommPlan'),
                    }
                })
                .then((response) =>{this.isLoading = false
                    this.txnHandle =  response.data.ManikJSon[0].JSon0[0].TxnHandle
                    var openGateway = document.getElementById("paymentGateway")
                    openGateway.click()
                })
                .catch(() =>{
                    this.isLoading = false;
                })
        }
           
        },
        openPaymentGateway: function(){
            
            window.location.href = 'https://pg.instaciti.com/Payment/Index/' + this.txnHandle
        }
    
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
